<template>
  <div class="v360" ref="elV360">
    <div class="v360-main-wrap">
      <button
        class="rb-btn-option rb-btn-fav"
        aria-label="Add to Favorites"
        @click.prevent="saveFavorites($event, diamond)"
      >
        <template v-if="isFaved(diamond)">
          <icon-heart-full />
        </template>
        <template v-else>
          <icon-heart />
        </template>
      </button>
      <loader v-if="loading" />
      <div
        :class="[`v360-image`, { 'v360-remote-thumb': !isV360 }]"
        v-if="!playing"
        :style="`background-image: url('${imgUrl}'); background-repeat: no-repeat; background-size: contain; background-position: 50% 50%;`"
      ></div>
      <template v-if="mode === 'video'">
        <div class="v360-video" v-if="playing">
          <template v-if="isV360">
            <iframe class="v360-iframe" :src="iframeUrl"></iframe>
          </template>
          <template v-else
            ><video class="video" muted="muted" playsinline ref="elVideo" loop>
              <source :src="videoUrl" type="video/mp4" /></video
          ></template>
        </div>
      </template>
    </div>
    <template v-if="mode === 'video'">
      <div class="v360-controls">
        <div class="v360-btns-wrap">
          <button
            class="v360-btn"
            aria-label="Play Video"
            @click.prevent="playVideo"
            v-if="!playing"
          >
            <icon-play />
          </button>
          <button
            class="v360-btn"
            aria-label="Stop Video"
            @click.prevent="stopVideo"
            v-if="playing"
          >
            <icon-pause />
          </button>
          <span>{{ playing ? "Stop" : "Play" }}</span>
        </div>
        <button
          class="rb-btn-default-video"
          aria-label="This is a sample video notice"
          @click.prevent="notifyPopupSampleVideo"
          v-if="isSampleVideo"
        >
          <span>This is a sample video</span>
          <span class="rb-info-icon">i</span>
        </button>
        <gia-certificate /></div
    ></template>
  </div>
</template>

<script>
/**
 * Displays diamond thumb and MP4 video or connects to iframe to display V360 image sequence
 *
 * @props
 * api: Object
 * diamond: Object
 * mode: String
 *
 * @implements
 * FavsMixin
 *
 */
import {
  v360LoadSUrl,
  v360GetSubdomain,
  v360GetDiamondName,
  v360IsVideo,
} from "../lib";
import IconPlay from "@/components/icons/IconPlay";
import IconPause from "@/components/icons/IconPause";
import GiaCertificate from "@/components/GiaCertificate";
import Loader from "@/components/Loader";
import IconHeart from "@/components/icons/IconHeart";
import IconHeartFull from "@/components/icons/IconHeartFull";
import FavsMixin from "@/mixins/FavsMixin";
export default {
  mixins: [FavsMixin],
  components: {
    IconPlay,
    IconPause,
    GiaCertificate,
    Loader,
    IconHeart,
    IconHeartFull,
  },
  props: {
    api: {
      type: Object,
    },
    diamond: {
      type: Object,
    },
    mode: {
      type: String,
      default: "image",
    },
  },
  computed: {
    videoUrl: function () {
      return this.diamond.video_url !== null && this.diamond.video_url !== ""
        ? this.diamond.video_url
        : this.diamond.diamond_defaults.video_url;
    },
    isV360: function () {
      return v360IsVideo(this.videoUrl);
    },
    isSampleVideo: function () {
      return this.diamond.use_default_video && this.diamond.video_url;
    },
  },
  data: function () {
    return {
      companyId: "233",
      loading: false,
      loaded: false,
      playing: false,
      subdomain: null,
      diamondName: null,
      imgUrl: "",
      iframeUrl: "",
      loadImageObserver: null,
      thumbLoaded: false,
    };
  },
  watch: {
    subdomain: function () {
      if (this.subdomain) {
        this.imgUrl = this.api.stillUrl
          .replace("[subdomain]", this.subdomain)
          .replace("[company]", this.companyId)
          .replace("[diamond]", this.diamondName);
        this.iframeUrl = `${this.api.iframeUrl}?diamond=${this.diamondName}&c=${this.companyId}&s=${this.subdomain}`;
      }
    },
  },
  mounted: function () {
    // console.log(this.diamond);
    /* this.getDiamondName();
    this.loadSUrl(); */
    this.initObserver();
  },
  methods: {
    initObserver: function () {
      this.loadImageObserver = new IntersectionObserver(
        (event) => {
          if (event.length && event[0].isIntersecting) {
            this.loadThumbnail();
          }
        },
        {
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      this.loadImageObserver.observe(this.$refs.elV360);
    },
    loadThumbnail: function () {
      if (this.thumbLoaded) return;
      if (
        this.diamond.image_file_url ||
        (this.diamond.default_video && this.diamond.default_video.image_url)
      ) {
        this.imgUrl = this.diamond.image_file_url
          ? this.diamond.image_file_url
          : this.diamond.default_video.image_url;
        this.loading = false;
        this.loaded = true;
        this.thumbLoaded = true;
      } else {
        this.getDiamondName();
        this.loadSUrl();
      }
    },
    getDiamondName: function () {
      if (this.isV360) {
        this.diamondName = v360GetDiamondName(this.videoUrl);
      } else {
        // try and get diamondName from default_video
        this.diamondName =
          this.diamond.default_video &&
          this.diamond.default_video.video_url &&
          v360IsVideo(this.diamond.default_video.video_url)
            ? v360GetDiamondName(this.diamond.default_video.video_url)
            : "";
      }
    },
    loadSUrl: async function () {
      this.loading = true;
      const url = await v360LoadSUrl(
        "https://v360.in/getSURL.aspx/getSURLDataWithVersion",
        this.diamondName,
        this.companyId
      );
      // console.log(url);
      if (!url || !url.d) return;
      var sd = v360GetSubdomain(url.d);
      if (sd.indexOf("s7.") > -1) sd = sd.replace("s7.", "s10.");
      this.subdomain = sd;

      this.loading = false;
      this.loaded = true;
      this.thumbLoaded = true;
    },
    playVideo: function () {
      this.playing = true;
      if (!this.isV360) {
        this.$nextTick(() => {
          this.$refs.elVideo.play();
        });
      }
    },
    stopVideo: function () {
      this.playing = false;
    },
    notifyPopupSampleVideo: function () {
      this.broadcast("rb-open-popup", { id: "rb-popup-sample-video" });
    },
  },
};
</script>
